import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'src/components/atoms/button/button';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Label from 'src/components/atoms/label/label';
import { Select } from 'src/components/atoms/select/select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Anagraphic } from 'src/models/user.model';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { editAnagraphic } from 'src/reducers/anagraphic.reducer';
import { validationSchema } from 'src/utils/validation-utils';
import { defaultAnagraphicForm } from '../../../../../utils/anagraphic-utils';
import Spinner from '../../../../atoms/spinner/spinner';

interface Props {
  userId: number;
  anagraphic?: Anagraphic;
}

export const AnagraphicForm = (props: Props) => {
  const { userId, anagraphic } = props;
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(state => state.anagraphic);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: 'onChange',
    defaultValues: defaultAnagraphicForm,
  });

  const sexOptions = [
    { value: 'M', label: 'Maschio' },
    { value: 'F', label: 'Femmina' },
  ];

  const watchSex = watch('sex');

  const onSubmit = (data: Anagraphic) => {
    dispatch(editAnagraphic({ anagraphic: data, userId }));
  };

  useEffect(() => {
    if (anagraphic) {
      reset(anagraphic);
    }
  }, [anagraphic, reset]);

  return (
    <Form>
      <FormRow col="2">
        <FormItem>
          <Label>Nome</Label>
          <input type="text" {...register('firstname', validationSchema.required)} />
          <FormError error={errors?.firstname} validation={validationSchema.required} />
        </FormItem>
        <FormItem>
          <Label>Cognome</Label>
          <input type="text" {...register('lastname', validationSchema.required)} />
          <FormError error={errors?.lastname} validation={validationSchema.required} />
        </FormItem>
      </FormRow>
      <FormRow col="2">
        <FormItem>
          <Label>Nato a</Label>
          <input type="text" {...register('birthPlace', validationSchema.required)} />
          <FormError error={errors?.birthPlace} validation={validationSchema.required} />
        </FormItem>
        <FormItem>
          <Label>Nato il</Label>
          <DatePicker
            selected={watch('birthDate')}
            onChange={date => setValue('birthDate', date)}
            dateFormat="dd/MM/yyyy"
            maxDate={new Date()}
          />
          <FormError error={errors?.birthDate} validation={validationSchema.required} />
        </FormItem>
      </FormRow>
      <FormRow col="2">
        <FormItem>
          <Label>Sesso</Label>
          <Select selected={watchSex as string} options={sexOptions} onSelect={option => setValue('sex', option.value)} />
          <FormError error={errors?.sex} validation={validationSchema.required} />
        </FormItem>
        <FormItem>
          <Label>Codice Fiscale</Label>
          <input type="text" {...register('fiscalCode', validationSchema.fiscalCode)} />
          <FormError error={errors?.fiscalCode} validation={validationSchema.required} />
        </FormItem>
      </FormRow>
      <FormRow col="2">
        <FormItem>
          <Label>Email personale</Label>
          <input type="email" {...register('email', validationSchema.email)} />
          <FormError error={errors?.email} validation={validationSchema.email} />
        </FormItem>
        <FormItem>
          <Label>N. di telefono</Label>
          <input type="text" {...register('phoneNumber', validationSchema.required)} />
          <FormError error={errors?.phoneNumber} validation={validationSchema.required} />
        </FormItem>
      </FormRow>
      <FormRow col="2">
        <FormItem>
          <Label>Note</Label>
          <input type="note" {...register('note')} />
          <FormError error={errors?.note} />
        </FormItem>
      </FormRow>

      <FormItem>
        <Button
          color="white"
          size="md"
          mode="outline"
          rounded="rounded-md"
          fullWidth
          disabled={!isValid || loading}
          onClick={handleSubmit(onSubmit)}
        >
          {loading ? <Spinner /> : 'Salva'}
        </Button>
      </FormItem>
    </Form>
  );
};
